// extracted by mini-css-extract-plugin
export default {"wrapper":"TableResetFilters_wrapper__4DbdU"};